import { useCallback, useEffect, useState } from 'react';
import type SwiperInstance from 'swiper';

import { ArrowLeftIcon, ArrowRightIcon, Button } from '@motorway/mw-highway-code';

import cypressIds from 'Components/cypress_ids.json';
import { applyCypressData } from 'Utilities/helpers';

const navigationButtonConfig: Partial<typeof Button> = {
	showLabel: false,
	size: 'small',
	variant: 'tertiary',
};

interface SimilarVehiclesCarouselNavigationProps {
	onSlideNext: () => void;
	onSlidePrev: () => void;
	swiperInstance: Nullable<SwiperInstance>;
}

export const SimilarVehiclesCarouselNavigation: React.FC<SimilarVehiclesCarouselNavigationProps> = ({
	onSlideNext,
	onSlidePrev,
	swiperInstance,
}) => {
	const [isPrevDisabled, setIsPrevDisabled] = useState(true);
	const [isNextDisabled, setIsNextDisabled] = useState(false);

	const onCheckDisabledState = useCallback(() => {
		if (!swiperInstance) return;
		setIsNextDisabled(swiperInstance.isEnd);
		setIsPrevDisabled(swiperInstance.isBeginning);
	}, [swiperInstance]);

	useEffect(() => {
		onCheckDisabledState();
	}, [swiperInstance, onCheckDisabledState]);

	const onNextClick = () => {
		onSlideNext();
		onCheckDisabledState();
	};

	const onPrevClick = () => {
		onSlidePrev();
		onCheckDisabledState();
	};

	return (
		<>
			<Button
				disabled={isPrevDisabled}
				icon={ArrowLeftIcon}
				label="Prev"
				onClick={onPrevClick}
				{...navigationButtonConfig}
				{...applyCypressData(cypressIds.buttons.similarVehiclesCarouselPrev)}
			/>
			<Button
				disabled={isNextDisabled}
				icon={ArrowRightIcon}
				label="Next"
				onClick={onNextClick}
				{...navigationButtonConfig}
				{...applyCypressData(cypressIds.buttons.similarVehiclesCarouselNext)}
			/>
		</>
	);
};
